import React from "react";
import { LockKeyIcon, WarningOctagonIcon } from "@phosphor-icons/react";
import { Field, Panel } from "@/components/ldc01/Ldc01Ui";
import { EXECUTION_CONTROLS_AUTHORISED, NP } from "@/lib/ldc01";
import { allMandatoryPass } from "@/lib/ldc01Gates";

export function ExecuteStep({ status, gates, dryJob, user, manifest, env }) {
  const open = gates.filter((x) => x.state !== "PASS");
  const unlocked = EXECUTION_CONTROLS_AUTHORISED && allMandatoryPass(gates); // always false until gate D1
  return (
    <div className="space-y-5" data-testid="ldc01-execute-step">
      <div className="flex gap-3 p-4 rounded-sm border border-red-500/40 bg-red-500/5" data-testid="ldc01-destructive-warning">
        <WarningOctagonIcon size={22} weight="fill" className="text-red-400 shrink-0" />
        <div className="text-sm text-red-200">
          <div className="font-semibold">Destructive, one-time operation</div>
          <div className="text-red-200/80 text-xs mt-1">Removes only the fixed, server-pinned manifest records. No record selection, no collection-wide deletion and no reset of document numbering.</div>
        </div>
      </div>
      <Panel title="Execution confirmation" subtitle="All values are read from the server. None of them can be edited." tone="danger">
        <Field label="Approved manifest reference" value={manifest?.sha256 ? `${manifest.sha256} · ${manifest.draft_status || ""}` : status?.manifest_sha256 || NP} mono testId="ldc01-exec-manifest" />
        <Field label="Target record count" value={manifest?.integrity === "PASS" ? `${manifest.total} (manifest) · dry-run ${dryJob?.report?.total_targets ?? "—"}` : NP} mono muted={manifest?.integrity !== "PASS"} testId="ldc01-exec-count" />
        <Field label="Database / environment" value={status?.db ? `${status.db} · identity ${env?.overall || "NOT VERIFIED"}` : NP} mono testId="ldc01-exec-db" />
        <Field label="Authorized operator" value={`${user?.email || "—"} · execute authorisation NOT VERIFIED`} mono testId="ldc01-exec-operator" />
        <Field label="Verification timestamp" value={dryJob?.finished_at || NP} mono muted={!dryJob?.finished_at} testId="ldc01-exec-verified-at" />
        <Field label="Job reference" value={dryJob?.id || NP} mono muted={!dryJob?.id} testId="ldc01-exec-job-ref" />
        <div className="mt-4">
          <label className="overline" htmlFor="ldc01-confirm">Final confirmation</label>
          <input id="ldc01-confirm" disabled readOnly value="" placeholder="Locked — confirmation not available in this phase"
            data-testid="ldc01-exec-confirm-input"
            className="mt-1 w-full h-10 px-3 bg-[var(--bg-0)] border border-[var(--border)] rounded-sm text-sm text-zinc-500 cursor-not-allowed" />
        </div>
        <button type="button" disabled={!unlocked} aria-disabled="true" data-testid="ldc01-exec-button"
          className="mt-4 w-full sm:w-auto inline-flex items-center justify-center gap-2 px-5 h-10 rounded-sm bg-zinc-800 text-zinc-500 text-sm font-semibold cursor-not-allowed">
          <LockKeyIcon size={15} weight="bold" /> Execute Cleanup — Locked
        </button>
        <div className="mt-4 text-xs text-zinc-400 space-y-1" data-testid="ldc01-exec-lock-reasons">
          <div>Locked: execution controls are not authorised (C5-C1 / C5-C2 Phase A1 — read-only).</div>
          {open.length > 0 && <div>Gates not passed: {open.map((x) => x.label).join(", ")}.</div>}
        </div>
      </Panel>
    </div>
  );
}
